import React, { FC } from 'react';
import AIProductIntro from '../AIProductIntro';
import styles from './AIProductIntroList.module.scss';

interface FeatureItem {
  /** 特性标题 */
  title: string;
  /** 特性描述 */
  description: string;
}

interface ProductIntroItem {
  /** 视频封面图 */
  poster: string;
  /** 视频源地址（可为空，为空时仅展示封面图） */
  videoSource?: string;
  /** 产品标题（数组，支持多行） */
  titles: string[];
  /** 产品口号 */
  slogan: string;
  /** 特性列表 */
  features: FeatureItem[];
  /** 按钮文本 */
  buttonText: string;
  /** 按钮链接 */
  buttonUrl: string;
  /** 是否外部链接 */
  linkOut?: boolean;
}

interface Props {
  /** AI 产品介绍列表数据 */
  productIntroDataArr: ProductIntroItem[];
}

/**
 * AI 产品介绍列表组件
 * 展示带标题的 AI 产品介绍列表，内部渲染多个 AIProductIntro
 */
const AIProductIntroList: FC<Props> = (props) => {
  const { productIntroDataArr } = props;

  return (
    <div className={styles['ai-product-intro-list']}>
      <h2 className={styles['ai-product-intro-list-title']}>AI 工具</h2>
      {productIntroDataArr.map((data, index) => (
        <AIProductIntro key={index} {...data} />
      ))}
    </div>
  );
};

AIProductIntroList.displayName = 'AIProductIntroList';
export default AIProductIntroList;
